import React from "react";

interface Profile {
  id: string;
  type: string;
  title: string;
  shortDescription: string;
  image: string;
  gumroadLink: string;
}

interface ProfileCardProps {
  profile: Profile;
  highlight?: boolean; // Add the highlight property
}

const ProfileCard: React.FC<ProfileCardProps> = ({
  profile,
  highlight = false,
}) => {
  // Default to false
  const cardClasses = ` rounded-lg overflow-hidden sh flex flex-col h-full transition-all ${
    highlight
      ? "border-2 text-black bg-yellow-300 border-yellow-300 shadow-[0_5px_20px_yellow] shadow-yellow-400/30 "
      : "bg-white bg-opacity-[3%] text-white" // Conditional classes
  }`;

  const cardButtonClasses = `  py-2 px-4 rounded-full flex-1 text-center transition-colors ${
    highlight
      ? " bg-opacity-30 bg-white hover:bg-opacity-70 border-yellow-600 border-2"
      : " bg-opacity-10 bg-white hover:bg-green-700" // Conditional classes
  }`;

  return (
    <div className={cardClasses}>
      {" "}
      {/* Use dynamic class */}
      <img
        src={profile.image}
        alt={profile.title}
        className="w-full object-cover aspect-square"
      />
      <div className="p-4 flex-grow">
        <h2 className="text-xl font-bold">{profile.title}</h2>
        <p className="opacity-70 mt-2">{profile.shortDescription}</p>
      </div>
      <div className="mt-4 flex justify-between gap-4 p-4">
        <a
          href={profile.gumroadLink}
          target="_blank"
          aria-label={profile.shortDescription}
          rel="noopener noreferrer"
          className={cardButtonClasses}
        >
          Learn more
        </a>
      </div>
    </div>
  );
};

export default ProfileCard;
